import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import moment from 'moment';
import { Tooltip, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import GMATSubscriptionCheck from '../../RestAPI/GMATSubscription';
import PartnerGMATSubscriptionCheck from '../../RestAPI/PartnerSubscription/GMATSubscription';
import language from '../../../assets/languages/language';
import { showFailure } from '../../../common/toast';
import AppRoutes from '../../config/AppRoutes';
/* eslint-disable*/
class Quizzes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      token: '',
      idname: '',
      chapters: [
        {
          chapter_no: 1,
          chapter_name: 'Integrated Reasoning',
        },
        {
          chapter_no: 2,
          chapter_name: 'Quantitative Reasoning',
        },
        {
          chapter_no: 3,
          chapter_name: 'Verbal Reasoning',
        },
      ],
      all_checked_state: true,
      radio_checked_question: 0,
      deleteItemId: '',
      radio_checked_priority: 'none',
      radio_checked_reasoning: 0,
      single_clicked_val: '',
      getallabondQuiz: '',
      getallcompleteQuiz: '',
      quiz_length_state: '',
      display_loader: 'show_block',
      tooltips: [
        {
          placement: `${language.LC().SELECT_HERE_NUMBER}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().ALL_INCOMPLETE_QUIZ}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().SEE_THE_DETAILS}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().Priority_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().unanswered_selected}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().wronganswered_selected}`,
          text_align: 'left',
        },
      ],
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      reasoning: this.state.radio_checked_reasoning,
    };

    this.abandonedQuizzes(data);

    FD.callAPI(App_data.backend_api + '/gmat_quizes/getallQuiz_length', data).then(
      resp_quiz_length => {
        // console.log(resp_quiz_length.quiz_length);
        if (resp_quiz_length.success) {
          this.setState({ quiz_length_state: resp_quiz_length.quiz_length });
        } else {
          this.setState({ display_loader: 'hide_block' });
          showFailure(resp.message);
        }
      },
    );
  }

  abandonedQuizzes = async data => {
    //console.log("abandonedQuizzes", data);

    await FD.callAPI(App_data.backend_api + '/gmat_quizes/getallQuiz', data).then(resp => {
      if (resp.success) {
        var getallabondQuiz = [];
        var completed_quiz = [];
        var dataString = JSON.stringify(resp.getallQuiz);
        var dataReason = JSON.parse(dataString);
        if (!dataReason.length) {
          this.setState({ display_loader: 'hide_block' });
        }
        for (var i = 0; i < dataReason.length; i++) {
          if (dataReason[i].count_tot == dataReason[i].number_questions) {
            completed_quiz.push(dataReason[i]);
          } else {
            getallabondQuiz.push(dataReason[i]);
          }
          if (i == dataReason.length - 1) {
            this.setState({ display_loader: 'hide_block' });
          }
        }
        this.setState({
          getallabondQuiz: getallabondQuiz,
          getallcompleteQuiz: completed_quiz,
        });
      } else {
        this.setState({ display_loader: 'hide_block' });
        showFailure(resp.message);
      }
      return resp;
    });
  };

  _all_Checked = () => {
    var checkboxes = document.getElementsByName('approve[]');
    var all_Checked = document.getElementById('all_Checked');
    if (all_Checked.checked) {
      this.setState({ all_checked_state: true }, function all_checked_state() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = '';
        }
      });
    } else {
      this.setState({ all_checked_state: false }, function all_checked_state() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = 'FALSE';
        }
      });
    }
  };

  _single_Checked(items, index_value, e) {
    this.setState({ radio_checked_reasoning: index_value });
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      reasoning: index_value,
    };
    console.log('I am inside single checked');
    FD.callAPI(App_data.backend_api + '/gmat_quizes/getallQuiz_length', data).then(
      resp_quiz_length => {
        if (resp_quiz_length.success) {
          this.setState({ quiz_length_state: resp_quiz_length.quiz_length });
        } else {
          this.setState({ display_loader: 'hide_block' });
          showFailure(resp.message);
        }
      },
    );
  }

  /*_changeIncludetimer(){
    if(this.state.include_timer)
    {
      this.setState({ include_timer:!this.state.include_timer });
    }
    else{
      this.setState({ include_timer:!this.state.include_timer });
    }    	
  }*/

  /*_changeSaveresult(){
    if(this.state.save_results)
    {
      this.setState({ save_results:!this.state.save_results });
    }
    else{
      this.setState({ save_results:!this.state.save_results });
    }    
  }*/

  _createQuiz = async () => {
    this.setState({ display_loader: 'show_block' });
    var data = { token: this.state.token, idname: this.state.idname };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({ display_loader: 'hide_block' });
          showFailure('Please Upgrade Your Account');
        } else {
          this.setState({
            cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
            cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = 'gmat';
                var isInArray_var = false;

                isInArray_var = await PartnerGMATSubscriptionCheck.checkGMATSubscription(
                  selectedmen,
                  exam_data,
                  this.state.cfaUnlimitedPackage,
                  this.state.cfaUnlimitedActiveExam,
                );
                console.log(isInArray_var, '<========partner==========');
                if (isInArray_var) {
                  var question_length_val = document.querySelector(
                    'input[name="number_questions"]:checked',
                  ).value;
                  var timer_value,
                    chapterAll = '';
                  timer_value = this.state.quiz_length_state[this.state.radio_checked_question]
                    .timer_value;
                  if (this.state.all_checked_state) {
                    // console.log('if	 working')
                    var dataString = JSON.stringify(this.state.chapters);
                    var dataReason = JSON.parse(dataString);
                    var chapterall_id = [];
                    for (var i = 0; i < dataReason.length; i++) {
                      chapterall_id.push(dataReason[i].chapter_no);
                    }

                    chapterAll = chapterall_id;
                    var data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      chapterAll: [`${this.state.radio_checked_reasoning + 1}`],
                      questionquize: parseInt(question_length_val),
                      priority: this.state.radio_checked_priority,
                      // reasoning: chapterAll.length
                      //   ? chapterAll[0] === '1'
                      //     ? 'Integrated Reasoning'
                      //     : chapterAll[0] === '2'
                      //     ? 'Quantitative Reasoning'
                      //     : 'Verbal Reasoning'
                      //   : 'Verbal Reasoning',
                      reasoning:
                        this.state.radio_checked_reasoning == 0
                          ? 'Integrated Reasoning'
                          : this.state.radio_checked_reasoning == 1
                            ? 'Quantitative Reasoning'
                            : 'Verbal Reasoning',
                    };
                    FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuizequestion', data).then(
                      resp => {
                        if (resp.success) {
                          var retun_all_chapter = JSON.stringify(resp.chapters);
                          var chapterParse = JSON.parse(retun_all_chapter);
                          var question_id = [];
                          var myJson = {
                            question_count: '',
                            all_questions: {},
                            readings: {},
                            cases: {},
                          };
                          for (var i = 0; i < chapterParse.length; i++) {
                            var objName = 'q' + i;
                            var objValue = chapterParse[i].id;
                            myJson.all_questions[i] = objValue;
                            myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
                            myJson.cases[i] = chapterParse[i].case_id;
                            question_id.push(chapterParse[i].id);
                          }
                          myJson.question_count = question_id.length;
                          var questions = JSON.stringify(myJson);
                          var data = {
                            token: this.state.token,
                            idname: this.state.idname,
                            number_questions: myJson.question_count,
                            questions: questions,
                            timer_value: timer_value,
                          };
                          FD.callAPI(App_data.backend_api + '/gmat_quizes/createQuiz', data).then(
                            resp => {
                              if (resp.success) {
                                this.setState({ display_loader: 'hide_block' });
                                this.context.router.push({
                                  pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
                                    ':quiz_id',
                                    resp.last_id,
                                  ).replace(':status_send', 'no'),
                                  //   `/gmat_beforestart/${resp.last_id}/${''}`,
                                  // state: {
                                  //   token: this.state.token,
                                  //   idname: this.state.idname,
                                  //   quiz_id: resp.last_id,
                                  //   status_send: '',
                                  // },
                                });
                              } else {
                                //console.log(resp.success);
                              }
                            },
                          );
                        } else {
                          this.setState({ display_loader: 'hide_block' });
                          showFailure(resp.message);
                        }
                        return resp;
                      },
                    );
                  } else {
                    // console.log('else working')
                    var checkboxes = document.getElementsByName('approve[]');
                    var i = 0;
                    var single_clicked_value = [];
                    if (this.state.single_clicked_val == '') {
                      for (i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].checked) {
                          // console.log(i+'----------'+checkboxes[i].value);
                          single_clicked_value.push(checkboxes[i].value);
                        }
                      }

                      chapterAll = single_clicked_value;
                      // console.log(chapterAll)
                      var data = {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapterAll: chapterAll,
                        questionquize: parseInt(question_length_val),
                        priority: this.state.radio_checked_priority,
                        // reasoning: chapterAll.length
                        //   ? chapterAll[0] === '1'
                        //     ? 'Integrated Reasoning'
                        //     : chapterAll[0] === '2'
                        //     ? 'Quantitative Reasoning'
                        //     : 'Verbal Reasoning'
                        //   : 'Verbal Reasoning',
                        reasoning:
                          this.state.radio_checked_reasoning == 0
                            ? 'Integrated Reasoning'
                            : this.state.radio_checked_reasoning == 1
                              ? 'Quantitative Reasoning'
                              : 'Verbal Reasoning',
                      };

                      FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuizequestion', data).then(
                        resp => {
                          if (resp.success) {
                            var retun_all_chapter = JSON.stringify(resp.chapters);
                            var chapterParse = JSON.parse(retun_all_chapter);
                            var question_id = [];
                            var myJson = {
                              question_count: '',
                              all_questions: {},
                              readings: {},
                              cases: {},
                            };
                            for (var i = 0; i < chapterParse.length; i++) {
                              var objName = 'q' + i;
                              var objValue = chapterParse[i].id;
                              myJson.all_questions[i] = objValue;
                              myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
                              question_id.push(chapterParse[i].id);
                              myJson.cases[i] = chapterParse[i].case_id;
                            }
                            myJson.question_count = question_id.length;
                            var questions = JSON.stringify(myJson);
                            var data_insert = {
                              token: this.state.token,
                              idname: this.state.idname,
                              number_questions: myJson.question_count,
                              questions: questions,
                              timer_value: timer_value,
                            };
                            FD.callAPI(
                              App_data.backend_api + '/gmat_quizes/createQuiz',
                              data_insert,
                            ).then(resp => {
                              if (resp.success) {
                                this.context.router.push({
                                  pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
                                    ':quiz_id',
                                    resp.last_id,
                                  ).replace(':status_send', 'no'),

                                  //   `/gmat_beforestart/${resp.last_id}`,
                                  // state: {
                                  //   token: this.state.token,
                                  //   idname: this.state.idname,
                                  //   quiz_id: resp.last_id,
                                  // },
                                });
                              } else {
                                // console.log(resp.success);
                              }
                            });
                          } else {
                            this.setState({ display_loader: 'hide_block' });
                            showFailure(resp.message);
                          }
                          return resp;
                        },
                      );
                    } else {
                      chapterAll = this.state.single_clicked_val;
                      var data = {
                        token: this.state.token,
                        idname: this.state.idname,
                        chapterAll: chapterAll,
                        questionquize: parseInt(question_length_val),
                        priority: this.state.radio_checked_priority,
                        // reasoning: chapterAll.length
                        //   ? chapterAll[0] === '1'
                        //     ? 'Integrated Reasoning'
                        //     : chapterAll[0] === '2'
                        //     ? 'Quantitative Reasoning'
                        //     : 'Verbal Reasoning'
                        //   : 'Verbal Reasoning',
                        reasoning: this.state.radio_checked_reasoning,
                      };
                      FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuizequestion', data).then(
                        resp => {
                          if (resp.success) {
                            var retun_all_chapter = JSON.stringify(resp.chapters);
                            var chapterParse = JSON.parse(retun_all_chapter);
                            var question_id = [];
                            var myJson = {
                              question_count: '',
                              all_questions: {},
                              readings: {},
                              cases: {},
                            };
                            for (var i = 0; i < chapterParse.length; i++) {
                              var objName = 'q' + i;
                              var objValue = chapterParse[i].id;
                              myJson.all_questions[i] = objValue;
                              myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
                              question_id.push(chapterParse[i].id);
                              myJson.cases[i] = chapterParse[i].case_id;
                            }
                            myJson.question_count = question_id.length;
                            var questions = JSON.stringify(myJson);
                            var data_insert = {
                              token: this.state.token,
                              idname: this.state.idname,
                              number_questions: myJson.question_count,
                              questions: questions,
                              timer_value: timer_value,
                            };
                            FD.callAPI(
                              App_data.backend_api + '/gmat_quizes/createQuiz',
                              data_insert,
                            ).then(resp => {
                              if (resp.success) {
                                this.context.router.push({
                                  pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
                                    ':quiz_id',
                                    resp.last_id,
                                  ).replace(':status_send', 'no'),
                                  //   `/gmat_beforestart/${resp.last_id}`,
                                  // state: {
                                  //   token: this.state.token,
                                  //   idname: this.state.idname,
                                  //   quiz_id: resp.last_id,
                                  // },
                                });
                              } else {
                                //console.log(resp.success);
                              }
                            });
                          } else {
                            this.setState({ display_loader: 'hide_block' });
                            showFailure(resp.message);
                          }
                          return resp;
                        },
                      );
                    }
                  }
                } else {
                  this.setState({ display_loader: 'hide_block' });
                  showFailure('Please Upgrade Your Account');
                }
              } else {
                this.setState({ display_loader: 'hide_block' });
                showFailure('Please Upgrade Your Account');
              }
            },
          );
        }
      } else {
        this.setState({
          cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
          cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
        });
        var data_arr = resp.profileInfo.exam_selected
          ? JSON.parse(resp.profileInfo.exam_selected)
          : null;
        var dataset = {
          token: this.state.token,
          idname: this.state.idname,
          examid: data_arr,
        };
        FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
          async resp_exam => {
            var exam_data = resp_exam.examData;
            var selectedmen = 'gmat';
            var isInArray_var = false;
            isInArray_var = await GMATSubscriptionCheck.checkGMATQuizSubscription(
              selectedmen,
              exam_data,
              this.state.cfaUnlimitedPackage,
              this.state.cfaUnlimitedActiveExam,
            );
            console.log('check subscription in gamt sections===>', isInArray_var);
            if (isInArray_var) {
              var question_length_val = document.querySelector(
                'input[name="number_questions"]:checked',
              ).value;
              var timer_value,
                chapterAll = '';
              timer_value = this.state.quiz_length_state[this.state.radio_checked_question]
                .timer_value;
              if (this.state.all_checked_state) {
                // console.log('if	 working')
                var dataString = JSON.stringify(this.state.chapters);
                var dataReason = JSON.parse(dataString);
                var chapterall_id = [];
                for (var i = 0; i < dataReason.length; i++) {
                  chapterall_id.push(dataReason[i].chapter_no);
                }

                chapterAll = chapterall_id;
                var data = {
                  token: this.state.token,
                  idname: this.state.idname,
                  chapterAll: [`${this.state.radio_checked_reasoning + 1}`],
                  questionquize: parseInt(question_length_val),
                  priority: this.state.radio_checked_priority,
                  // reasoning: chapterAll.length
                  //   ? chapterAll[0] === '1'
                  //     ? 'Integrated Reasoning'
                  //     : chapterAll[0] === '2'
                  //     ? 'Quantitative Reasoning'
                  //     : 'Verbal Reasoning'
                  //   : 'Verbal Reasoning',
                  reasoning:
                    this.state.radio_checked_reasoning == 0
                      ? 'Integrated Reasoning'
                      : this.state.radio_checked_reasoning == 1
                        ? 'Quantitative Reasoning'
                        : 'Verbal Reasoning',
                };
                FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuizequestion', data).then(
                  resp => {
                    if (resp.success) {
                      var retun_all_chapter = JSON.stringify(resp.chapters);
                      var chapterParse = JSON.parse(retun_all_chapter);
                      var question_id = [];
                      var myJson = {
                        question_count: '',
                        all_questions: {},
                        readings: {},
                        cases: {},
                      };
                      for (var i = 0; i < chapterParse.length; i++) {
                        var objName = 'q' + i;
                        var objValue = chapterParse[i].id;
                        myJson.all_questions[i] = objValue;
                        myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
                        myJson.cases[i] = chapterParse[i].case_id;
                        question_id.push(chapterParse[i].id);
                      }
                      myJson.question_count = question_id.length;
                      var questions = JSON.stringify(myJson);
                      var data = {
                        token: this.state.token,
                        idname: this.state.idname,
                        number_questions: myJson.question_count,
                        questions: questions,
                        timer_value: timer_value,
                      };
                      FD.callAPI(App_data.backend_api + '/gmat_quizes/createQuiz', data).then(
                        resp => {
                          if (resp.success) {
                            this.setState({ display_loader: 'hide_block' });
                            this.context.router.push({
                              pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
                                ':quiz_id',
                                resp.last_id,
                              ).replace(':status_send', 'no'),
                              //   `/gmat_beforestart/${resp.last_id}/${''}`,
                              // state: {
                              //   token: this.state.token,
                              //   idname: this.state.idname,
                              //   quiz_id: resp.last_id,
                              //   status_send: '',
                              // },
                            });
                          } else {
                            //console.log(resp.success);
                          }
                        },
                      );
                    } else {
                      this.setState({ display_loader: 'hide_block' });
                      showFailure(resp.message);
                    }
                    return resp;
                  },
                );
              } else {
                // console.log('else working')
                var checkboxes = document.getElementsByName('approve[]');
                var i = 0;
                var single_clicked_value = [];
                if (this.state.single_clicked_val == '') {
                  for (i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked) {
                      // console.log(i+'----------'+checkboxes[i].value);
                      single_clicked_value.push(checkboxes[i].value);
                    }
                  }

                  chapterAll = single_clicked_value;
                  // console.log(chapterAll)
                  var data = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterAll: chapterAll,
                    questionquize: parseInt(question_length_val),
                    priority: this.state.radio_checked_priority,
                    // reasoning: chapterAll.length
                    //   ? chapterAll[0] === '1'
                    //     ? 'Integrated Reasoning'
                    //     : chapterAll[0] === '2'
                    //     ? 'Quantitative Reasoning'
                    //     : 'Verbal Reasoning'
                    //   : 'Verbal Reasoning',
                    reasoning:
                      this.state.radio_checked_reasoning == 0
                        ? 'Integrated Reasoning'
                        : this.state.radio_checked_reasoning == 1
                          ? 'Quantitative Reasoning'
                          : 'Verbal Reasoning',
                  };

                  FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuizequestion', data).then(
                    resp => {
                      if (resp.success) {
                        var retun_all_chapter = JSON.stringify(resp.chapters);
                        var chapterParse = JSON.parse(retun_all_chapter);
                        var question_id = [];
                        var myJson = {
                          question_count: '',
                          all_questions: {},
                          readings: {},
                          cases: {},
                        };
                        for (var i = 0; i < chapterParse.length; i++) {
                          var objName = 'q' + i;
                          var objValue = chapterParse[i].id;
                          myJson.all_questions[i] = objValue;
                          myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
                          question_id.push(chapterParse[i].id);
                          myJson.cases[i] = chapterParse[i].case_id;
                        }
                        myJson.question_count = question_id.length;
                        var questions = JSON.stringify(myJson);
                        var data_insert = {
                          token: this.state.token,
                          idname: this.state.idname,
                          number_questions: myJson.question_count,
                          questions: questions,
                          timer_value: timer_value,
                        };
                        FD.callAPI(
                          App_data.backend_api + '/gmat_quizes/createQuiz',
                          data_insert,
                        ).then(resp => {
                          if (resp.success) {
                            this.context.router.push({
                              pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
                                ':quiz_id',
                                resp.last_id,
                              ).replace(':status_send', 'no'),

                              //   `/gmat_beforestart/${resp.last_id}`,
                              // state: {
                              //   token: this.state.token,
                              //   idname: this.state.idname,
                              //   quiz_id: resp.last_id,
                              // },
                            });
                          } else {
                            // console.log(resp.success);
                          }
                        });
                      } else {
                        this.setState({ display_loader: 'hide_block' });
                        showFailure(resp.message);
                      }
                      return resp;
                    },
                  );
                } else {
                  chapterAll = this.state.single_clicked_val;
                  var data = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapterAll: chapterAll,
                    questionquize: parseInt(question_length_val),
                    priority: this.state.radio_checked_priority,
                    // reasoning: chapterAll.length
                    //   ? chapterAll[0] === '1'
                    //     ? 'Integrated Reasoning'
                    //     : chapterAll[0] === '2'
                    //     ? 'Quantitative Reasoning'
                    //     : 'Verbal Reasoning'
                    //   : 'Verbal Reasoning',
                    reasoning: this.state.radio_checked_reasoning,
                  };
                  FD.callAPI(App_data.backend_api + '/gmat_quizes/getQuizequestion', data).then(
                    resp => {
                      if (resp.success) {
                        var retun_all_chapter = JSON.stringify(resp.chapters);
                        var chapterParse = JSON.parse(retun_all_chapter);
                        var question_id = [];
                        var myJson = {
                          question_count: '',
                          all_questions: {},
                          readings: {},
                          cases: {},
                        };
                        for (var i = 0; i < chapterParse.length; i++) {
                          var objName = 'q' + i;
                          var objValue = chapterParse[i].id;
                          myJson.all_questions[i] = objValue;
                          myJson.readings[i] = chapterParse[i]['gmat_reading.type'];
                          question_id.push(chapterParse[i].id);
                          myJson.cases[i] = chapterParse[i].case_id;
                        }
                        myJson.question_count = question_id.length;
                        var questions = JSON.stringify(myJson);
                        var data_insert = {
                          token: this.state.token,
                          idname: this.state.idname,
                          number_questions: myJson.question_count,
                          questions: questions,
                          timer_value: timer_value,
                        };
                        FD.callAPI(
                          App_data.backend_api + '/gmat_quizes/createQuiz',
                          data_insert,
                        ).then(resp => {
                          if (resp.success) {
                            this.context.router.push({
                              pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(
                                ':quiz_id',
                                resp.last_id,
                              ).replace(':status_send', 'no'),
                              //   `/gmat_beforestart/${resp.last_id}`,
                              // state: {
                              //   token: this.state.token,
                              //   idname: this.state.idname,
                              //   quiz_id: resp.last_id,
                              // },
                            });
                          } else {
                            //console.log(resp.success);
                          }
                        });
                      } else {
                        this.setState({ display_loader: 'hide_block' });
                        showFailure(resp.message);
                      }
                      return resp;
                    },
                  );
                }
              }
            } else {
              this.setState({ display_loader: 'hide_block' });
              showFailure('Please Upgrade Your Account');
            }
          },
        );
      }
    });
  };

  _checkAbondon(items, e) {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', items.id).replace(
        ':status_send',
        'abondon',
      ),

      //   `/gmat_beforestart/${items.id}/${'abondon'}`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   quiz_id: items.id,
      //   status_send: 'abondon',
      // },
    });
  }

  _checkCompleted(items, e) {
    this.context.router.push({
      pathname: AppRoutes.GMAT_QUIZZES_BEFORE_START.replace(':quiz_id', items.id).replace(
        ':status_send',
        'completed',
      ),

      //   `/gmat_beforestart/${items.id}/${'completed'}`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   quiz_id: items.id,
      //   status_send: 'completed',
      // },
    });
  }

  _length_Checked(items, index_value, e) {
    this.setState({ radio_checked_question: index_value });
  }

  _priority_selected(e) {
    // console.log(e.target.value)
    this.setState({ radio_checked_priority: e.target.value });
  }

  deleteQuizzes = (items, e) => {
    //console.log("deleteQuizzes", items);
    if (!this.state.alert_status) {
      this.setState({
        deleteItemId: items.id,
        alert_status: true,
      });
    } else {
      this.setState({
        deleteItemId: '',
        alert_status: false,
      });
    }
  };

  deleteToggleDone = async e => {
    //console.log("calllinggg!!!!");
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      deleteItemId: this.state.deleteItemId,
    };
    await FD.callAPI(App_data.backend_api + '/gmat_quizes/deleteAbandonedQuizzes', data).then(
      async resp => {
        if (resp.success) {
          await this.abandonedQuizzes(data);
          this.setState({
            deleteItemId: '',
            alert_status: false,
          });
        }
      },
    );
  };
  render() {
    let chapters_all = this.state.chapters;
    let chapter_data = '';

    if (this.state.chapters.length) {
      chapter_data = chapters_all.map((items, index) => (
        <div className='col-md-6' key={index}>
          {/* <label className='check_container'> */}
          <label className='radio_container'>
            {items.chapter_name}
            <input
              // type='checkbox'
              type='radio'
              name='approve[]'
              value={items.chapter_no}
              checked={this.state.radio_checked_reasoning == index}
              onClick={this._single_Checked.bind(this, items, index)}
            />
            <span className='checkmark' />
          </label>
        </div>
      ));
    }

    let abandoned_all = this.state.getallabondQuiz;
    let abandoned_data = '';

    if (this.state.getallabondQuiz.length) {
      abandoned_data = abandoned_all.map((items, index) => (
        <tr key={index}>
          <td className='text_red'>
            <strong>Id: {items.id}</strong>
          </td>
          <td>
            {language.LC().QUESTIONS} : {items.number_questions}
          </td>
          <td>
            {language.LC().DATE}: <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkAbondon.bind(this, items)}>
              {language.LC().RECOVER}
            </span>
          </td>
          <td className=''>
            <span className='delete-quizzes' onClick={() => this.deleteQuizzes(items)}>
              {' '}
              <i className='fa fa-trash' aria-hidden='true' /> Delete{' '}
            </span>
          </td>
        </tr>
      ));
    } else {
      abandoned_data = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let getallcompleteQuiz_all = this.state.getallcompleteQuiz;
    let getallcompleteQuiz_data = '';

    if (this.state.getallcompleteQuiz.length) {
      getallcompleteQuiz_data = getallcompleteQuiz_all.map((items, index) => (
        <tr key={index} className='quize-row'>
          <td className='text_green'>
            <strong>
              {language.LC().ID}: {items.id}
            </strong>
          </td>
          <td>
            {language.LC().QUESTIONS}: {items.number_questions}
          </td>
          <td>
            {language.LC().DATE}: <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkCompleted.bind(this, items)}>
              {language.LC().VIEW}
            </span>
          </td>
        </tr>
      ));
    } else {
      getallcompleteQuiz_data = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let quiz_length_state_all = this.state.quiz_length_state;
    let quiz_length_state_data = '';
    if (this.state.quiz_length_state.length) {
      quiz_length_state_data = quiz_length_state_all.map((items, index) => (
        <label className='radio_container' key={index}>
          {items.quiz_length} {language.LC().QUESTIONS}
          <input
            type='radio'
            id='number_questions_id'
            name='number_questions'
            value={items.quiz_length}
            checked={this.state.radio_checked_question == index}
            onClick={this._length_Checked.bind(this, items, index)}
          />
          <span className='checkmark' />
        </label>
      ));
    }

    return (
      <div>
        <div className='animated fadeIn'>
          {/* <div className="row"> */}
          {/* <div className="col-md-8 margin_bottom_20"> */}
          <div className='margin_bottom_20 d-flex justify-content-between'>
            <h1 className='section_head'>{language.LC().CFA_LEVEL_I_QUIZZES}</h1>
            {/* </div> */}
            {/* <div className="col-md-4 text-md-right margin_bottom_20"> */}
            <button className='btn btn-primary pointer_class' onClick={this._createQuiz.bind(this)}>
              {' '}
              {language.LC().CREATE_QUIZ}{' '}
            </button>
          </div>
          {/* </div> */}

          <div className='row'>
            <div className='col-lg-7'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().CONTENT}
                  {/* <div className='card-actions float-right'>
                    <label className='check_container margin_bottom_0'>
                      {' '}
                      {language.LC().ALL_CHAPTERS}
                      <input
                        type='checkbox'
                        id='all_Checked'
                        name='all_checked'
                        value='select'
                        onClick={this._all_Checked.bind(this)}
                        checked={this.state.all_checked_state}
                      />
                      <span className='checkmark' />
                    </label>
                  </div> */}
                </div>
                <div className='card-block padding_15'>
                  <div className='row'>{chapter_data}</div>
                </div>
              </div>

              <div className='card'>
                <div className='card-header'>
                  {language.LC().ABANDONED_QUIZZES}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='1'
                      id='1'
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    />
                  </div>
                </div>
                <div className='table_responsive_wrapper abandoned_quizzes_cards_scroll'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table'>
                      <tbody>{abandoned_data}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-5'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().Priorities_By}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='3'
                      id='3'
                      content={this.state.tooltips[3].placement}
                      place_tip={this.state.tooltips[3].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <label className='radio_container'>
                    {' '}
                    {language.LC().NONE}
                    <input
                      type='radio'
                      id='none'
                      name='none'
                      value='none'
                      checked={this.state.radio_checked_priority == 'none'}
                      onClick={this._priority_selected.bind(this)}
                    />
                    <span className='checkmark' />
                  </label>
                  <label className='radio_container'>
                    {language.LC().UNANSWERED}
                    <input
                      type='radio'
                      id='mark_unanswered'
                      name='mark_unanswered'
                      value='unanswered'
                      checked={this.state.radio_checked_priority == 'unanswered'}
                      onClick={this._priority_selected.bind(this)}
                    />
                    <span className='checkmark' />
                  </label>
                  <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                    <TooltipItem
                      key='4'
                      id='4'
                      content={this.state.tooltips[4].placement}
                      place_tip={this.state.tooltips[4].text_align}
                    />
                  </div>
                  <label className='radio_container'>
                    {' '}
                    {language.LC().Wrong_answers}
                    <input
                      type='radio'
                      id='mark_unattempted'
                      name='mark_unattempted'
                      value='wrongquestion'
                      checked={this.state.radio_checked_priority == 'wrongquestion'}
                      onClick={this._priority_selected.bind(this)}
                    />
                    <span className='checkmark' />
                  </label>
                  <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                    <TooltipItem
                      key='5'
                      id='5'
                      content={this.state.tooltips[5].placement}
                      place_tip={this.state.tooltips[5].text_align}
                    />
                  </div>
                </div>
              </div>

              <div className='card'>
                <div className='card-header'>
                  {language.LC().LENGTH}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  {quiz_length_state_data}
                  {/*<div className="checkbox checkbox-info checkbox-circle radio_wrapper">
			                    </div>*/}
                </div>
              </div>

              <div className='card'>
                <div className='card-header'>
                  {language.LC().COMPLETED_QUIZZES}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='2'
                      id='2'
                      content={this.state.tooltips[2].placement}
                      place_tip={this.state.tooltips[2].text_align}
                    />
                  </div>
                </div>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table'>
                      {/*<thead>    											
											<tr>
								                <th></th>
								                <th></th>
								                <th></th>
								                <th></th>
											</tr>
										</thead>*/}
                      <tbody>{getallcompleteQuiz_data}</tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/*<div className="col-sm-4"> 
						<div className="card">
						    <div className="card-header">
						      Other Options
						      <div className="card-actions card_action_tooltip float-right">
						      </div>
						    </div>
						    <div className="card-block">
						    	<div className="checkbox checkbox-info checkbox-circle">
						    		<div>
				                        <input type="checkbox" value="1"  name="include_timer" checked={this.state.include_timer} onClick={this._changeIncludetimer.bind(this)}/>
				                        <label htmlFor="checkbox8">
				                          Include A Timer
				                        </label>
			                        </div>
			                        <div>
				                        <input type="checkbox" value="1"  name="save_results" checked={this.state.save_results} onClick={this._changeSaveresult.bind(this)}/>
				                        <label htmlFor="checkbox8">
				                          Save My Results
				                        </label>
			                        </div>		                        
			                    </div>				        
						    </div>
					  	</div> 
					</div>*/}
          </div>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.deleteQuizzes}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.deleteQuizzes}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.deleteToggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

function Dateform(props) {
  var myDate = moment(props.created_d).format('YYYY-MM-DD');
  return <span>{myDate}</span>;
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          alt=''
          className=''
          width='18'
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default Quizzes;



// WEBPACK FOOTER //
// ./src/views/GMAT/Quizzes/Quizzes.js